import { toast } from "react-toastify";
const initialState = {
  homeData: [],
  newProducts: [],
  levels: [],
  faqList: [],
  loading: false,
  error: null,
  searchResult: [],
  contactData: null,
  arList: [],
  blogList: [],
  blog: null,
  province: [],
  city: [],
};

const grades = [
  "پیش دبستان",
  "اول",
  "دوم",
  "سوم",
  "چهارم",
  "پنجم",
  "ششم",
  "هفتم",
  "هشتم",
  "نهم",
  "دهم",
  "یازدهم",
  "دوازدهم",
];
export default function publicApi(state = initialState, action) {
  let { type, data } = action;
  switch (type) {
    case "public/homePage":
      let itemsLevel;
      //  if (window.innerWidth > 1000) {
      const jadidTarin = data.filter(
        (item) => item.title === "کتاب‌های دانوین"
      );
      itemsLevel =
        jadidTarin[0] && jadidTarin[0].data
          ? jadidTarin[0].data
              .map((item) => item.book.gradeId * 1)
              .sort((a, b) => a - b)
              .map((e) => grades[e])
          : [];
      itemsLevel.unshift("پایه تحصیلی");
      //  }

      return {
        ...state,
        loading: false,
        levels: [...new Set(itemsLevel)],
        error: null,
        homeData: data,
      };
    case "user/logout":
    case "user/login":
    case "user/otp/login":
      return { ...state, homeData: [] };
    case "public/filter":
      const realList =
        state.newProducts.length === 0
          ? state.homeData.filter((item) => item.title === "کتاب‌های دانوین")[0]
              .data
          : state.newProducts;
      if (state.newProducts.length === 0) {
        state = {
          ...state,
          newProducts: realList,
        };
      }
      const level = data.levels;
      const search = data.search;
      if (level.length > 0 || search) {
        localStorage.setItem("filter", "ON");
      } else {
        return {
          ...state,
          loading: false,
          error: null,
          homeData: state.homeData.map((item) =>
            item.title === "کتاب‌های دانوین"
              ? { ...item, data: state.newProducts }
              : { ...item }
          ),
          newProducts: [],
        };
      }
      let byLevelFilter = [];
      if (level.length > 0) {
        level.forEach((item1) => {
          for (let i = 0; i < realList.length; i++) {
            if (grades[realList[i].book.gradeId] === item1) {
              byLevelFilter.push(realList[i]);
            }
          }
        });
      } else {
        byLevelFilter = realList;
      }

      // let bySubjectFilter = [];
      // if (subject.length > 0) {
      //   subject.map((item1) => {
      //     for (let i = 0; i < byLevelFilter.length; i++) {
      //       if (byLevelFilter[i].name === item1) {
      //         bySubjectFilter.push(byLevelFilter[i]);
      //       }
      //     }
      //   });
      // } else {
      //   bySubjectFilter = byLevelFilter;
      // }

      const bySearchFilter = search
        ? byLevelFilter.filter((item1) => item1.name.indexOf(search) !== -1)
        : byLevelFilter;
      // if (sort === "گران ترین") {
      //   finalSort = bySearchFilter.sort((item1, item2) => {
      //     return item1.product[0].price - item2.product[0].price;
      //   });
      // } else {
      //   finalSort = bySearchFilter;
      // }

      return {
        ...state,
        loading: false,
        error: null,
        homeData: state.homeData.map((item) =>
          item.title === "کتاب‌های دانوین"
            ? { ...item, data: bySearchFilter }
            : { ...item }
        ),
      };
    case "faq/list":
      return { ...state, loading: false, error: null, faqList: data };
    case "public/province":
      return { ...state, loading: false, error: null, province: data };
    case "public/city":
      return { ...state, loading: false, error: null, city: data };
    case "public/faq/activate":
      return {
        ...state,
        loading: false,
        error: null,
        faqList: state.faqList.map((item) =>
          item.id === data
            ? { ...item, active: !item.active }
            : { ...item, active: false }
        ),
      };

    case "public/faq/search":
      return {
        ...state,
        loading: false,
        error: null,
        searchResult: state.faqList.filter(
          (item) =>
            item.title.indexOf(data) !== -1 ||
            item.description.indexOf(data) !== -1
        ),
      };
    case "public/contact":
      return { ...state, loading: false, error: null, contactData: data };
    case "public/ar":
      return { ...state, loading: false, error: null, arList: data };
    case "public/blogList":
      return { ...state, loading: false, error: null, blogList: data };
    case "public/blogInfo":
      return { ...state, loading: false, error: null, blog: data };
    case "public/loading":
      return { ...state, loading: true };
    case "public/error":
      toast.error(data.message);
      return { ...state, loading: false, error: data.message };

    default:
      return state;
  }
}
